import { getJbpHpContactsCrud } from '../lib'

export const removeChangeRequest = async (id: number) => {
  const crud = getJbpHpContactsCrud('welcome-flow-remove-request')

  await crud.delete(
    {
      formId: '1217',
      code: 'jbp-hp-contact-change-request-1217',
    },
    {
      EntryId: id,
    },
    'EntryId'
  )
}
